export const TransactionBaseTypes = {
    CORPORATE:"سازمان",
    USER:"کاربر",
    DISCOUNT:"تخفیف",
    PLACE:"مرکز",
    INCOME:"درامد",
    PERSONNEL:"پرسنل",
    BENEFICIARY:"ذینفع",
    CORPORATE_PERSONNEL_DEPOSIT_PURCHASE:"پرداخت سازمان در خرید کاربر (شارژ)",
    CORPORATE_PERSONNEL_CREDIT_PURCHASE:"پرداخت سازمان در خرید کاربر (اعتبار)",
    USER_PERSONAL_PURCHASE:"پرداخت شخصی",
    USER_NON_WITHDRAWABLE_PURCHASE:"پرداخت از کیف پول جیم پین",
    CREDIT_PURCHASE:"پرداخت از اعتبار",
    CREDIT:"اعتبار",
    INTERNAL_TRANSFER:"جابجایی در کیف پول ها"


}
